import {
  AppBar,
  Button,
  Drawer,
  IconButton,
  InputBase,
  Paper,
  Toolbar,
  Typography,
} from "@material-ui/core";
// import { FaUserAlt, FaPlus, FaArrowLeft, FaTimes, FaPencilAlt } from 'react-icons/fa';
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
// import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
// import { InviteClientForm } from '../Modals';
import EditIcon from "@material-ui/icons/Edit";
import { App, User } from "app-interfaces";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useStateValue } from "../../config/AppContext";
import { UserStatus } from "../../types/StaticTypes";
import { createRenderingInfoPrinter, triggerDebuggerAndThrow } from "../../utils/debugging-utils";
import FaB from "../Utilities/FloatingActionButton";
import Icons from "../Utilities/Icons";
import LoadingSpinner from "../Utilities/LoadingSpinner";
import SfC from "../Utilities/SearchFilter";
import ClientAdd from "./ClientAdd";
import ClientDetails from "./ClientDetails";
import ClientEdit from "./ClientEdit";

const drawerWidth = 500;

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: drawerWidth,
    overflowX: "hidden",
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      backgroundColor: "white",
      boxShadow: "none",
      borderBottom: "1px solid lightgray",
    },
  },
  appBar1: {
    width: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? "100%" : drawerWidth,
    backgroundColor: "rgb(62, 127, 233)",
  },
  toolBar: {
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: 20,
    paddingRight: 5,
  },
  list_item: {
    padding: "12px 15px",
    fontSize: 14,
    backgroundColor: "#ffffff",
    cursor: "pointer",
    boxShadow: "0 0 1px 1px #cccccc57",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  client_head: {
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#3e7fe9",
    border: "1px solid #9b9b9b45",
    padding: "8px 10px",
    margin: 0,
    top: 70,
  },
}));

const printRenderingInfo = createRenderingInfoPrinter("ClientsListing");

export default function ClientsListing() {
  printRenderingInfo();

  const { ic_user, ic_invite_white } = Icons;
  const { t } = useTranslation();
  const { clients, Methods } = useStateValue() as {
    clients: App.State["clients"];
    Methods: App.Methods;
  };
  const history = useHistory();

  const [filtered, setFiltered] = React.useState<User.IUserClient[] | null>(null);
  const [toggle, setToggle] = React.useState(false);

  const [addClientDrawer, setAddClientDrawer] = React.useState(false);
  const [inviteClientDrawer, setinviteClientDrawer] = React.useState(false);
  const [viewClientDrawer, setViewClientDrawer] = React.useState(false);
  const [viewEditDrawer, setEditClientDrawer] = React.useState(false);
  const [clientId, setClientId] = React.useState("");
  const classes = useStyles();

  if (!clients || !Methods) {
    return (
      <div style={{ padding: "50% 25%" }}>
        <LoadingSpinner />
      </div>
    );
  }

  const handleEditCDrawer = (a: boolean) => {
    setEditClientDrawer(a);
    setAddClientDrawer(a);
  };

  // Client invite handler
  const handleInvite = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    await Methods.inviteClient(formData);
  };

  const handleEditDrawer = (id: string, open: boolean) => {
    setClientId(id);
    setViewClientDrawer(open);
  };
  // Generate individual client item
  const generateListItem = (client: any, i: number) => {
    return (
      <li
        key={i}
        // className='client-item'
        className={classes.list_item}
        onClick={() =>
          /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
            ? history.push(`/clients/${client.id}`)
            : handleEditDrawer(client.id, true)
        }
      >
        <span
          style={{ textTransform: "capitalize" }}
        >{`${client.first_name} ${client.last_name}`}</span>
        <span>
          <img
            alt="profile"
            style={{
              position: "relative",
              height: "30px",
              width: "30px",
              // right: '30px',
              backgroundColor: "#f8f8f8",
              borderRadius: "100%",
              objectFit: "cover",
            }}
            src={client.photo ? client.photo.medium : ic_user}
            onError={(event) => {
              event.currentTarget.src = ic_user;
              event.currentTarget.onerror = null;
              return true;
            }}
          />
          <span
            style={{
              position: "absolute",
              height: "11px",
              width: "11px",
              backgroundColor:
                client.reg_status === UserStatus.REGISTERED
                  ? "#7ed321"
                  : client.reg_status === UserStatus.INVITED
                  ? "#ffb319"
                  : "",
              borderRadius: "100%",
            }}
          />
        </span>
      </li>
    );
  };
  // Generate listing with alphabetical headers
  const generateHeadList = (accum: Array<any>, client: any, i: number) => {
    const head = client.last_name && client.last_name[0].toUpperCase();
    if (accum.find((el: any) => el.props.id === head.toUpperCase())) {
      accum = [...accum, generateListItem(client, i)];
      return accum;
    }
    accum = [
      ...accum,
      <p
        id={head}
        key={i + 100}
        // className='client-head'
        className={classes.client_head}
      >
        {head.toUpperCase()}
      </p>,
      generateListItem(client, i),
    ];
    return accum;
  };
  // Search / Filter handler
  const handleFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget.value === "") return setFiltered(null);
    const filter = new RegExp(e.currentTarget.value.trim(), "i");
    const filteredClients = clients.filter(
      (client) =>
        filter.test(client.first_name) ||
        filter.test(client.last_name) ||
        filter.test(`${client.first_name} ${client.last_name}`) ||
        filter.test(client.email)
    );
    return setFiltered(filteredClients);
  };

  const handle2drawers = () => {
    setEditClientDrawer(false);
    setAddClientDrawer(true);
  };

  return (
    <div id="client-listing">
      <div className="row justify-content-around">
        <div className="col-md-7">
          <SfC onChange={handleFilter} screen="clients" />
          <ul className="client-listing">
            {filtered
              ? filtered.reduce(generateHeadList, [])
              : clients.reduce(generateHeadList, [])}
          </ul>
        </div>
        {!/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && (
          <div
            className="col-md-4"
            style={{ height: "fit-content", position: "relative", bottom: 30 }}
          >
            <h5
              className="section-heading text-capitalize"
              style={{ color: "black", marginTop: 45, fontSize: 14 }}
            >
              {/* {t("Action")} */}
            </h5>
            <Paper
              onClick={() => setinviteClientDrawer(true)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 15,
                cursor: "pointer",
                backgroundColor: "#3e7fe9",
              }}
            >
              <span style={{ color: "#ffffff" }}>
                {t("Transfer client from another PT Flow trainer")}
              </span>
              {/* <PersonAddIcon style={{ color: '#ffffff' }} /> */}
              <img alt="" src={ic_invite_white} width="26" height="26" />
              {/* <FaUserAlt 
            color="#ffffff"
             /> */}
            </Paper>
            <Paper
              onClick={(_) =>
                /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
                  ? history.push("/clients/add")
                  : handle2drawers()
              }
              style={{
                display: "flex",
                backgroundColor: "#3e7fe9",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 15,
                padding: 15,
                cursor: "pointer",
              }}
            >
              <span style={{ color: "#ffffff" }}>{t("Add new client")}</span>
              <AddIcon style={{ color: "#ffffff", stroke: "var(--primary)" }} fontSize="large" />
              {/* <FaPlus 
            color="#ffffff"
             /> */}
            </Paper>
          </div>
        )}
      </div>
      {/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && (
        <FaB
          show={toggle}
          options={["Add", "Invite"]}
          onClick={() => setToggle(!toggle)}
          onAdd={() => history.push("/clients/add")}
          onInvite={() => setinviteClientDrawer(true)}
          onAddSuperset={triggerDebuggerAndThrow}
          onAddExercise={triggerDebuggerAndThrow}
        />
      )}

      <Drawer
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="right"
        open={addClientDrawer}
        onClose={(_) => setAddClientDrawer(false)}
      >
        <AppBar position="fixed" className={classes.appBar1}>
          <Toolbar>
            <div className="d-flex flex-column" style={{ width: "100%" }}>
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  {viewEditDrawer ? (
                    <IconButton onClick={(_) => handleEditCDrawer(false)}>
                      <ArrowBackIcon style={{ color: "#ffffff" }} />
                      {/* <FaArrowLeft color="white" /> */}
                    </IconButton>
                  ) : (
                    <IconButton onClick={(_) => setAddClientDrawer(false)}>
                      <ArrowBackIcon style={{ color: "#ffffff" }} />
                      {/* <FaArrowLeft color="white" /> */}
                    </IconButton>
                  )}
                  <Typography variant="h6" noWrap>
                    {viewEditDrawer ? t("Edit client") : t("Add new client")}
                  </Typography>
                </div>
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <div style={{ marginTop: "4em", padding: 20 }}>
          {viewEditDrawer ? (
            <ClientEdit id={clientId} />
          ) : (
            <ClientAdd
              onClientAddedSuccessfully={() => {
                // moved from the inside of client add
                window.innerWidth > 700 ? setAddClientDrawer(false) : history.goBack();
              }}
            />
          )}
        </div>
      </Drawer>
      <Drawer
        classes={{
          paper: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
            ? "100%"
            : classes.drawerPaper,
        }}
        anchor="right"
        open={inviteClientDrawer}
        onClose={(_) => setinviteClientDrawer(false)}
      >
        <AppBar className={classes.appBar1} style={{ position: "initial" }}>
          <Toolbar>
            <div className="d-flex flex-column">
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <IconButton onClick={(_) => setinviteClientDrawer(false)}>
                    {/* <FaArrowLeft color="white" /> */}
                    <ArrowBackIcon style={{ color: "#ffffff" }} />
                  </IconButton>
                  <Typography variant="h6" noWrap>
                    {t("Invite")}
                  </Typography>
                </div>
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <div style={{ margin: "2rem 22px 0" }}>
          <form onSubmit={handleInvite} className="w-100">
            <Paper component="form" style={{ padding: "6px 10px", marginBottom: "2rem" }}>
              <InputBase
                style={{ paddingLeft: 10, fontSize: 15, color: "gray" }}
                name="email"
                type="text"
                required
                title=""
                placeholder={t(`Enter email address`)}
              />
            </Paper>
            <Typography variant="body2" style={{ color: "gray" }} noWrap>
              {t("Invitation will be sent immediately to the above email.")}
            </Typography>
            <div className="button-group mt-4 w-100">
              <button
                type="submit"
                className="btn w-100 text-white"
                style={{ padding: 10, backgroundColor: "rgb(62, 127, 233)" }}
              >
                {t("Invite")}
              </button>
            </div>
          </form>
        </div>
      </Drawer>

      <Drawer
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="right"
        open={viewClientDrawer}
        onClose={(_) => setViewClientDrawer(false)}
      >
        <div
          style={{
            paddingBottom: "141px",
            backgroundSize: "cover",
            paddingLeft: 5,
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
          }}
        >
          <IconButton style={{ zIndex: 1 }} onClick={(_) => setViewClientDrawer(false)}>
            <ArrowBackIcon style={{ color: "#ffffff" }} />
          </IconButton>
          <Button
            variant="contained"
            style={{
              background: "white",
              borderRadius: 30,
              width: 90,
              zIndex: 1,
            }}
            size="small"
            onClick={(_) => handleEditCDrawer(true)}
          >
            <span style={{ textTransform: "capitalize", fontWeight: "bold", fontSize: 13 }}>
              <EditIcon style={{ fontSize: 15 }} />
              {t("Edit")}
            </span>
          </Button>
        </div>
        <div style={{ padding: 20, position: "absolute", height: "100%" }}>
          <ClientDetails id={clientId} />
        </div>
      </Drawer>
    </div>
  );
}
